<script setup>
import { computed } from 'vue'

const staffCount = computed(() => {
    return window.prebook.staffs
})
</script>
<template>
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <!-- loader item -->
        <div v-for="i in staffCount" class="flex flex-col gap-3 animate-pulse">
            <div class="w-full h-[119px] rounded-lg bg-[#F2F4F7]"></div>
            <div class="flex flex-col gap-3 py-2 pl-2 pr-3">
                <div class="w-full h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[34px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
        </div>
    </div>
</template>